import { render } from "./notFound.vue?vue&type=template&id=c1d49a78&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=js"
export * from "./notFound.vue?vue&type=script&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=c1d49a78&scoped=true&lang=scss"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d49a78"]])

export default __exports__